<template>
  <Transition name="loading">
    <div
      class="loading-overlay"
      :class="{ 'vh-100': fullHeight }"
      v-if="loading"
    >
      <div
        class="d-flex justify-content-center mt-3 h-100"
        :class="(!title || !message) && 'align-items-center'"
      >
        <img
          class="position-relative mx-auto"
          :src="useAsset(`img/credit-line/loading-spinner.gif`)"
          alt="loading gif"
        />
      </div>
      <div v-if="title || message">
        <div class="fs-2 fw-bold my-3 text-center px-3" v-if="title">
          {{ title }}
        </div>
        <div class="fs-6 text-center px-5" v-if="message">
          {{ message }}
        </div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";

export default defineComponent({
  name: "LoadingOverlay",
  emits: ["onClose"],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      useAsset,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.loading-overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  color: $pj-color-green;
  font-size: 40px;
  background-color: white;
}
</style>
